<template>
  <div class="post-aside__list-poplat">
    <!-- popular list -->
    <div class="post-list__popular">
      <h4 class="display-1 text-xs-center mb-4">Popular Stories</h4>

      <v-container grid-list-xl>
        <v-layout wrap>
          <v-flex
            v-for="post in popularPosts"
            :key="post.id"
            xs12
            class="mb-1"
          >
            <v-card
              :href="`https://kontinentalist.com/stories/${post.slug}`"
              flat
              target="_blank"
            >
              <v-layout wrap>
                <v-flex class="xs12 md5 px-0 pt-0">
                  <div>
                    <img
                      v-if="post.featured_img"
                      :src="post.featured_img.url"
                      class="fluid">
                  </div>
                </v-flex>

                <v-flex class="xs12 md7 px-0 pt-0">
                  <div>
                    <!-- category / region -->
                    <span class="font-secondary primary--text">{{ post.categories[0].name }} / {{ post.region.name }}</span>

                    <!-- post title -->
                    <h3 class="body-2 font-weight-bold mt-2 mb-3">{{ post.title }}</h3>

                    <!-- author -->
                    <address class="body-1 font-secondary">by {{ post.author_name }}</address>
                  </div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

        </v-layout>
      </v-container>
    </div>

    <!-- latest list -->
    <div class="post-list__latest">
      <h4 class="display-1 text-xs-center mb-4">Latest Stories</h4>

      <v-container grid-list-xl>
        <v-layout wrap>
          <v-flex
            v-for="post in latestPosts"
            :key="post.id"
            xs12
            class="mb-1"
          >
            <v-card
              :href="`https://kontinentalist.com/stories/${post.slug}`"
              flat
              target="_blank"
            >
              <v-layout wrap>
                <v-flex class="xs12 md5 px-0">
                  <div>
                    <img
                      v-if="post.featured_img"
                      :src="post.featured_img.url"
                      class="fluid">
                  </div>
                </v-flex>

                <v-flex class="xs12 md7 px-0 pt-0">
                  <div>
                    <!-- category / region -->
                    <span class="font-secondary primary--text">{{ post.categories[0].name }} / {{ post.region.name }}</span>

                    <!-- post title -->
                    <h3 class="body-2 font-weight-bold mt-2 mb-3">{{ post.title }}</h3>

                    <!-- author -->
                    <address class="body-1 font-secondary">by {{ post.author_name }}</address>
                  </div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PostListPopLat',
  props: {
    popularPosts: {
      type: Array,
      required: true,
    },
    latestPosts: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="stylus" scoped>
.container.grid-list-xl {
  .layout {
    .flex {
      padding: 20px;
    }
  }
}

.v-card {
  background-color: #F8F4EE !important;

  h3 {
    transition: color 0.2s linear;
  }

  &:hover {
    h3 {
      color: #F38063 !important;
    }

    address {
      color: rgba(0, 0, 0, 0.7);
    }
  }
}
</style>
